import React from "react";

import Logo from "../../Logo/Logo";
import NavigationItems from "../../NavigationItems/NavigationItems";
import classes from "./SideDrawer.module.css";
import Backdrop from "../../UI/Backdrop/Backdrop";

const sideDrawer = (props) => {
    let attachedClasses = [classes.SideDrawer, classes.Close];
    if (props.open) {
        attachedClasses = [classes.SideDrawer, classes.Open];
    }
    return (
        <React.Fragment>
            <Backdrop show={props.open} clicked={props.closed} />
            <div className={attachedClasses.join(" ")} onClick={props.closed}>
                <div className={classes.Logo}>
                    <Logo clicked={props.clicked} />
                </div>

                <nav>
                    <NavigationItems isLoggedIn={props.isLoggedIn} />
                </nav>
            </div>
        </React.Fragment>
    );
};

export default sideDrawer;
